import * as React from 'react';

import DegreeHomeAppV2 from 'bundles/degree-home/components/v2/DegreeHomeApp';
import { useDegreePlanPropertiesContext } from 'bundles/degree-home/components/v3-dpm/context/DegreePlanPropertiesContext';
import useDegreeDataAndPermission from 'bundles/degree-home/utils/useDegreeDataAndPermission';

const DegreeHomeAppV2Container: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  const { location, userId, degreeSlug, degreeMetadata, membershipStatus, partners, degreeLoading } =
    useDegreeDataAndPermission();
  const { isDPMEnabled } = useDegreePlanPropertiesContext();

  if (membershipStatus === 'data_loading' || degreeLoading || isDPMEnabled === undefined) {
    return null;
  }

  return (
    <DegreeHomeAppV2
      location={location}
      userId={userId}
      degreeSlug={degreeSlug}
      degreeMetadata={degreeMetadata}
      membershipStatus={membershipStatus}
      partners={partners}
      isDPMEnabled={isDPMEnabled}
    >
      {children}
    </DegreeHomeAppV2>
  );
};

export default DegreeHomeAppV2Container;
